/**
 * Kanoniczne wartości z API (`final_title`) → forma do wyświetlenia uczniowi wg Pan/Pani.
 */
export function formatFinalTitleForStudent(
	canonicalTitle: string | undefined | null,
	personalTitle: string | undefined | null,
): string {
	const raw = String(canonicalTitle || '').trim();
	if (raw === '') {
		return '';
	}
	const female =
		String(personalTitle || '')
			.trim()
			.toLowerCase() === 'pani';

	if (raw === 'Finalista/ka') {
		return female ? 'Finalistka' : 'Finalista';
	}
	if (raw === 'Laureat/ka III stopnia') {
		return female ? 'Laureatka III stopnia' : 'Laureat III stopnia';
	}
	if (raw === 'Laureat/ka II stopnia') {
		return female ? 'Laureatka II stopnia' : 'Laureat II stopnia';
	}
	if (raw === 'Laureat/ka I stopnia') {
		return female ? 'Laureatka I stopnia' : 'Laureat I stopnia';
	}

	return raw;
}
